import { useState, ChangeEvent } from 'react';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';
import Button from '../../../juristec-ui/core/Button';
import { Container } from './styled/GroupsModal.styled';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import TextArea from '../../../juristec-ui/core/TextArea';

interface Props {
  onSubmit: (data: { name: string; description: string }) => void;
  hide: () => void;
  group?: {
    name: string;
    description: string;
  };
  mode?: 'create' | 'edit';
}

const GroupsModal = ({ onSubmit, hide, group, mode = 'create' }: Props) => {
  const [name, setName] = useState(group?.name || '');
  const [description, setDescription] = useState(group?.description || '');

  const handleSubmit = () => {
    onSubmit({ name, description });
    setName('');
    setDescription('');
    hide();
  };
  
  const handleDescriptionChange = (event: string | ChangeEvent<HTMLInputElement>) => {
    const value = typeof event === 'string' ? event : event.target.value;
    setDescription(value);
  };

  const handleNameChange = (event: string | ChangeEvent<HTMLInputElement>) => {
    const value = typeof event === 'string' ? event : event.target.value;
    setName(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleBlur = () => {
    if (!name || !description) {
      setName('');
      setDescription('');
    }
  };

  return (
    <Container>
      <InputTextLine
        autoFocus
        label="Nome do Grupo"
        value={name}
        setValue={handleNameChange}
        onChange={handleNameChange}
      />
      <TextArea
        // @ts-ignore
        label="Descrição"
        onChange={handleDescriptionChange}
        value={description}
        styleContainer={{ height: '35vh' }}
      />
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={hide}
          variant="outlined"
          color='primary'
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          variant="contained"
          color='primary'
          disabled={!name || !description}
        >
          {mode === 'create' ? 'Criar ' : 'Editar '} Grupo
        </Button>
      </ActionsGroup>
    </Container>
  );
};
export default GroupsModal;
